<template>
   <div class="search_box">
    <slot></slot>
    <div class="flex">
      <span class="btn search_btn" @click="subSearch">搜索</span>
      <span class="btn clear_btn" @click="subClear">重置</span>
     <!-- <button class="btn search_btn" @click="subSearch">搜索</button>
      <button class="btn clear_btn" @click="subClear">清空条件</button> -->
    </div>
   </div>
</template>

<script>
export default{
  props:{
    fromData:Object
  },
  methods:{
    //搜索
    subSearch(){
      this.$emit('subSearch');
    },
    //清空
    subClear(){
      this.fromData.searchCriteria = {};      
      this.$emit('subClear');
    }
  }
}
</script>

<style>
</style>
